import { call, put, takeLatest, select } from 'redux-saga/effects';
import type { PayloadAction } from '@reduxjs/toolkit';
import { uploadEventsSuccess, uploadEventsFailure } from '../slices/eventUploadSlice';
import { fetchUpcomingEventsRequest } from '../slices/upcomingEventsSlice';
import ENDPOINTS from '../../api/endPoints';

function* uploadEventsSaga(action: PayloadAction<File>): Generator<any, void, any> {
  try {
    const file = action.payload;
    const restaurantId = yield select((state) => state.clover.restaurantId);

    // Create FormData and append the file
    const formData = new FormData();
    formData.append('file', file);

    // Upload file to the API using fetch directly for FormData
    const response: Response = yield call(fetch, ENDPOINTS.uploadEvents, {
      method: 'POST',
      headers: {
        'restaurant-id': restaurantId
      },
      body: formData
    });

    // Try to get response body regardless of status
    let result;
    try {
      result = yield response.json();
    } catch (jsonError) {
      const textResponse = yield response.text();
    }

    if (!response.ok) {
      const errorMessage = result?.message || result?.error || `Upload failed with status ${response.status}`;
      throw new Error(errorMessage);
    }

    // Success
    yield put(uploadEventsSuccess());

    // Refresh upcoming events
    yield put(fetchUpcomingEventsRequest({ restaurantId, countryCode: 'US' }));

  } catch (error: any) {
    console.error('Upload error:', error);
    // Better error handling
    let errorMessage = 'Failed to upload events';
    
    if (error?.message) {
      errorMessage = error.message;
    } else if (error?.statusText) {
      errorMessage = `${error.status}: ${error.statusText}`;
    }
    
    yield put(uploadEventsFailure(errorMessage));
  }
}

export default function* eventUploadWatcher() {
  yield takeLatest('eventUpload/uploadEventsRequest', uploadEventsSaga);
}
